module.exports = __webpack_public_path__ + "static/img/two-ball-loading.aeb860af.gif";